import { Button, ButtonVariant, Intent, Popover, Position, Tag, Tooltip } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { LANDING_EDIT_MODE, LANDING_PRIMITIVE_PIN, LANDING_PRIMITIVE_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import rectangle_tool from "../../../../assets/img/rectangle.svg"
import oval_tool from "../../../../assets/img/oval.svg"
import line_tool from "../../../../assets/img/line.svg"
import star_tool from "../../../../assets/img/star.svg"
import heart_tool from "../../../../assets/img/heart.svg"
import order_tool from "../../../../assets/img/order.svg"
import curve_tool from "../../../../assets/img/curve.svg"
import pin_tool from "../../../../assets/img/pin.svg"
import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"
import { setCursor } from "." 

/* Protopia Ecosystem component */
export interface IFloatToolProps {
   
}
const FloatTool = (props: IFloatToolProps): JSX.Element => {
    const editMode                          = useLandingConsoleStore((state: ILandingConsoleStore) => state.editMode)
    const figureMode:LANDING_PRIMITIVE_TYPE | typeof LANDING_PRIMITIVE_PIN = useLandingConsoleStore((state: ILandingConsoleStore) => state.figureMode)
    const figures: any = {
        rectangle_tool,
        oval_tool,
        star_tool,
        heart_tool,
        order_tool,
        line_tool,
        curve_tool,
        pin_tool,
    }
    const setEdit = () => {
        useLandingConsoleStore.setState({ editMode: LANDING_EDIT_MODE.PRIMITIVES })
        setCursor("default")
    }
    const changeFigure = (figure : LANDING_PRIMITIVE_TYPE | typeof LANDING_PRIMITIVE_PIN) => {
        useLandingConsoleStore.setState({ figureMode: figure })
    }
    const isFloat = editMode === LANDING_EDIT_MODE.PRIMITIVES
    return <Popover
        modifiers={{
            arrow: { enabled: true },
            flip: { enabled: true },
            preventOverflow: { enabled: false },
            offset: { enabled: true, options: {
                offset: [ 0, 1 ],
            } }, 
        }}
        position={ Position.RIGHT_TOP }
        content={ <div className="floats-popover">
            {
                Object.values( LANDING_PRIMITIVE_TYPE ).map(figure => <Button 
                    variant={ figureMode === figure ? ButtonVariant.SOLID : ButtonVariant.MINIMAL} 
                    onClick={ () => changeFigure(figure) } 
                    key={figure}
                >
                    <div className={`d-flex flex-column align-items-center ${figureMode === figure ? "" : "opacity_5"}`}>
                        <img src={ figures[ `${figure}_tool` ] } alt="" height={15} className="panel-icon" /> 
                    </div>
                </Button>)
           } 
           <Button 
                variant={ figureMode === LANDING_PRIMITIVE_PIN ? ButtonVariant.SOLID : ButtonVariant.MINIMAL} 
                onClick={ () => changeFigure(LANDING_PRIMITIVE_PIN) }  
            >
                <div className={`d-flex flex-column align-items-center ${figureMode === LANDING_PRIMITIVE_PIN ? "" : "opacity_5"}`}>
                    <img src={ figures[ `${LANDING_PRIMITIVE_PIN}_tool` ] } alt="" height={15} className="panel-icon" /> 
                </div>
            </Button>
        </div> }
    >
        <Tooltip 
            content={ <div className="small letter-spacing-1 flex-centered">
                {__( "Draw figure" )}
                <Tag minimal className="ml-2 px-2 py-0"><div className="smallest text-light title">CTRL + F</div></Tag>
            </div> } 
            className=" ml-auto" 
            position="right"
            intent={Intent.PRIMARY}
            compact
            hoverOpenDelay={600}
            portalClassName="z-index-90"
            modifiers={{ 
                arrow: { enabled: true },
                flip: { enabled: true },
                preventOverflow: { enabled: false },
                offset: { 
                    enabled: true, 
                    options: {
                        offset: [0, 2],
                    } 
                }, 
            }}
        >
            <Button variant={ isFloat ? ButtonVariant.SOLID : ButtonVariant.MINIMAL} onClick={ setEdit } >
                <div className={ `d-flex flex-column align-items-center ${ isFloat ? "" : "opacity_5"}` }>
                    <img src={ figures[`${figureMode}_tool`] } alt="" height={15} className="panel-icon" /> 
                </div>
            </Button>
        </Tooltip>
    </Popover>
}
export default FloatTool